import defaultTo from 'lodash/defaultTo';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { UnclaimedSiteLabel } from '@atlassian/cssxp-utils-entitlement';

import { CloudChildProduct, CloudSubscription, Entitlement, SourceSystem } from '@atlassian/cssxp-typescommon';

import startCase from 'lodash/startCase';
import capitalize from 'lodash/capitalize';

export const getProductRegion = (product: CloudChildProduct | { region: string }) => {
  const { region = '' } = product;

  if (isNil(region)) {
    return '';
  }

  if (region.includes('-us-') || region.endsWith('-us')) {
    return 'US';
  }

  if (region.includes('-eu-') || region.endsWith('-eu')) {
    return 'EU';
  }

  return '';
};

function isCloudSubscription(entitlement: Entitlement): entitlement is CloudSubscription {
  return entitlement.isCloud === true;
}

export const getEntitlementName = (entitlement: Entitlement) => {
  const { baseProduct, productName, edition, sourceSystem } = entitlement;

  const cloudSiteProductNames = ['Atlassian Cloud', 'Atlassian OnDemand'];

  if (baseProduct === 'Statuspage' && entitlement.cloudSiteUrl && sourceSystem !== SourceSystem.HAMS) {
    return productName;
  }

  if (!isCloudSubscription(entitlement) || entitlement.isAddon) {
    return productName;
  }

  if (baseProduct === 'Statuspage' && sourceSystem === SourceSystem.HAMS) {
    return `${baseProduct} (see CCP entitlement)`;
  }

  if (baseProduct === 'Bitbucket') {
    return entitlement.cloudSiteUrl;
  }

  if (baseProduct === 'Trello') {
    if (edition) {
      return `${baseProduct} (${startCase(capitalize(edition))})`;
    }
  }

  if (cloudSiteProductNames.includes(productName)) {
    return isEmpty(entitlement.cloudSiteUrl) ? UnclaimedSiteLabel : entitlement.cloudSiteUrl;
  }

  // Some entitlements in the BDM have null base product names
  return defaultTo(baseProduct, productName);
};
